import React from "react";
import { Link } from "react-router-dom";
import { ArrowLeft } from "@phosphor-icons/react";

/** Shared frame for static pages (About / Privacy / Terms). */
export default function StaticPage({ eyebrow, title, children }) {
  return (
    <div className="px-5 pt-4 pb-2" data-testid="static-page">
      <Link
        to="/profile"
        className="inline-flex items-center gap-2 rounded-full bg-white border border-[#E6E3D8] px-4 py-2 text-sm font-medium text-[#1A2421] hover:bg-[#F0EFE9] transition-colors shadow-sm"
        data-testid="back-to-profile"
      >
        <ArrowLeft size={16} weight="bold" /> Back
      </Link>

      <div className="mt-5">
        <span className="label-eyebrow">{eyebrow}</span>
        <h1 className="font-serif-display text-3xl tracking-tight text-[#1A2421] mt-1">{title}</h1>
      </div>

      <div className="card-organic p-5 mt-5 text-sm text-[#1A2421] leading-relaxed space-y-4">
        {children}
      </div>

      <p className="text-[11px] text-[#5C6B62] text-center mt-6">Tally Carb Counter</p>
    </div>
  );
}
